import 'overlayscrollbars/css/OverlayScrollbars.css';
import cx from 'classnames';
import React from 'react';
import styles from './layout.module.scss';
import { Content } from './slots/content';
import { Footer } from './slots/footer';
import { Header } from './slots/header';
import { LeftSideBar } from './slots/left-sidebar';
import { RightSideBar } from './slots/right-sidebar';
export const Layout = ({ children, isAppLayout = false, ...restProps }) => {
    const childElements = React.Children.toArray(children);
    /** This helper function either retun valid react element or null */
    const getChildren = (type) => childElements.filter((child) => child.type === type);
    return (React.createElement("div", { className: styles.root, ...restProps },
        getChildren(Header),
        React.createElement("div", { className: cx({
                [styles.layoutContainer]: !isAppLayout,
                [styles.appLayout]: isAppLayout,
            }), "data-testid": "layout-testid" },
            getChildren(LeftSideBar),
            getChildren(Content),
            getChildren(RightSideBar)),
        getChildren(Footer)));
};
//# sourceMappingURL=layout.js.map